const utcFormat = Intl.DateTimeFormat('en-CA', {
  timeZone: 'UTC',
  month: 'numeric',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  hourCycle: 'h23'
})

export default {
  utcFormat: (d, type = 'full') => {
    const dObject = new Date(d)

    if (type === 'full') {
      d = utcFormat.format(dObject)
    } else if (type === 'object') {
      const dString = utcFormat.format(dObject)

      d = {
        datetime: dString,
        date: dString.slice(0, -10),
        default: new Date(dString + ' UTC')
      }
    }

    return d
  },
  localTime: (time, type = 'full', isUTC = true, showMeridiem = false, showTimezone = true) => {
    const selectedTime = time ? new Date(isUTC ? Date.parse(`${time} UTC`) : time) : new Date()

    let day = selectedTime.getDate()
        day = day > 9 ? day : '0' + day
    let month = selectedTime.getMonth() + 1
        month = month > 9 ? month : '0' + month
    let year = selectedTime.getFullYear()
    let hour = selectedTime.getHours()
        hour = hour > 9 ? hour : '0' + hour
    let minute = selectedTime.getMinutes()
        minute = minute > 9 ? minute : '0' + minute
    let second = selectedTime.getSeconds()
        second = second > 9 ? second : '0' + second

    let timezone = selectedTime.toString().match(/(\(.*\))/g)
    let meridiem = hour > 12 ? 'PM' : 'AM'

    if (timezone === null
        || typeof timezone[0] === 'undefined'
        || timezone[0] === '(Western Indonesia Time)') {
      timezone = 'WIB'
    } else if (timezone[0] === '(Central Indonesia Time)') {
      timezone = 'WITA'
    } else if (timezone[0] === '(Eastern Indonesia Time)') {
      timezone = 'WIT'
    } else {
      timezone = 'WIB'
    }

    if (type === 'date') {
      return `${day}/${month}/${year}`
    } else if (type === 'object') {
      return {
        day,
        month,
        year,
        hour,
        minute,
        second,
        date: `${day}/${month}/${year}`,
        full: `${day}/${month}/${year} ${hour}:${minute}:${second}${showMeridiem ? ' ' + meridiem : ''}${showTimezone ? ' ' + timezone : ''}`,
        timezone,
        meridiem,
        default: selectedTime
      }
    } else {
      return `${day}/${month}/${year} ${hour}:${minute}:${second}${showMeridiem ? ' ' + meridiem : ''}${showTimezone ? ' ' + timezone : ''}`
    }
  },
  localTimeReroute: (localTime) => {
    return `${localTime[3] + localTime[4]}/${localTime[0] + localTime[1]}/${localTime[6] + localTime[7] + localTime[8] + localTime[9]}`
  },
  roma: (d) => {
    if (d == 1) return 'I'
    if (d == 2) return 'II'
    if (d == 3) return 'III'
    if (d == 4) return 'IV'
    if (d == 5) return 'V'
    if (d == 6) return 'VI'
    if (d == 7) return 'VII'
    if (d == 8) return 'VII'
    if (d == 9) return 'IX'
    if (d == 10) return 'X'
    if (d == 11) return 'XI'
    if (d == 12) return 'XII'
  },
  generateQuery: (query, query2) => {
    const newQuery = {}

    for (var q in query) {
      if (typeof query[q] !== 'undefined' && query[q] !== null) newQuery[q] = query[q]
    }

    // add additional query if not exists
    for (var q2 in query2) {
      if (typeof newQuery[q2] === 'undefined' && query2[q2] !== null) newQuery[q2] = query2[q2]
    }

    return {
      query: newQuery,
      toString: new URLSearchParams(newQuery).toString()
    }
  },
  decToDMS: (cordinate) => {
    cordinate = parseFloat(cordinate);

    const deg = parseInt(cordinate)
    const minute = parseInt((cordinate - deg) * 60)
    const second = ((cordinate - deg) - (minute / 60)) * 3600

    return {
      d: deg,
      m: Number(minute).toFixed(2),
      s: Number(second).toFixed(2)
    }
  },
  dmsToString: (cordinate, a, b) => {
    let dmsString = `${cordinate.d}° ${cordinate.m}' ${cordinate.s}"`

    if (cordinate.d >= 0) {
      dmsString += ` ${a}`
    } else {
      dmsString += ` ${b}`
    }

    return dmsString
  },
  timeRemaining: (utcTime, showMinus = false) => {
    const currentDate = Date.now()
    const nextDate = (new Date(Date.parse(`${utcTime} UTC`))).getTime()

    if (currentDate >= nextDate) {
      if (!showMinus) return 'berakhir'

      const tmicro = currentDate - nextDate
      const tsecond = Math.floor(tmicro / 1000)

      if (tsecond >= 60) {
        const tminute = Math.floor(tsecond / 60)

        if (tminute >= 60) {
          const thour = Math.floor(tminute / 60)

          if (thour >= 24) {
            const tday = Math.floor(thour / 24)

            return `-${tday} hari`
          } else {
            return `-${thour} jam`
          }
        } else {
          return `-${tminute} menit`
        }
      } else {
        return `-${tsecond} detik`
      }
    } else {
      const tmicro = nextDate - currentDate
      const tsecond = Math.floor(tmicro / 1000)

      if (tsecond >= 60) {
        const tminute = Math.floor(tsecond / 60)

        if (tminute >= 60) {
          const thour = Math.floor(tminute / 60)

          if (thour >= 24) {
            const tday = Math.floor(thour / 24)

            return `${tday} hari`
          } else {
            return `${thour} jam`
          }
        } else {
          return `${tminute} menit`
        }
      } else {
        return `${tsecond} detik`
      }
    }
  },
  timeElapsed: (utcTime) => {
    const currentDate = Date.now()
    const selectedTime = (new Date(Date.parse(`${utcTime} UTC`))).getTime()
    const tsecond = currentDate - selectedTime

    if (tsecond >= 60) {
      const tminute = Math.floor(tsecond / 60)

      if (tminute >= 60) {
        const thour = Math.floor(tminute / 60)

        if (thour >= 24) {
          const tday = Math.floor(thour / 24)

          if (tday <= 31) {
            return `${tday} hari`
          } else {
            return this.localTime(utcTime)
          }
        } else {
          return `${thour} jam`
        }
      } else {
        return `${tminute} menit`
      }
    } else {
      return `${tsecond} detik`
    }
  },
  createRangeTime: function (timeSet, typeTime = 'before', offsetTime, showMeridiem = false, showTimezone = true) {
    const timeConfig = (1000 * 60 * 60 * (timeSet || 24))
    let rangeStart = 0
    let rangeEnd = 0

    offsetTime = offsetTime ? new Date(offsetTime).getTime() : Date.now()

    if (typeTime === 'before') {
      rangeEnd = offsetTime
      rangeStart = rangeEnd - timeConfig
    } else {
      rangeEnd = offsetTime
      rangeStart = rangeEnd + timeConfig
    }

    const rangeStartLocal = this.localTime(rangeStart, 'object', false, showMeridiem, showTimezone)
    const rangeEndLocal = this.localTime(rangeEnd, 'object', false, showMeridiem, showTimezone)

    return {
      startDate: rangeStartLocal.date,
      endDate: rangeEndLocal.date,
      startTime: rangeStartLocal.full,
      endTime: rangeEndLocal.full,
      startNumber: rangeStart,
      endNumber: rangeEnd,
      startDefault: rangeStartLocal.default,
      endDefault: rangeEndLocal.default
    }
  },
  distanceof: (cordinate1, cordinate2) => {
    const R = 6371e3
    const φ1 = cordinate1.lat * Math.PI/180 // φ, λ in radians
    const φ2 = cordinate2.lat * Math.PI/180
    const Δφ = (cordinate2.lat - cordinate1.lat) * Math.PI/180
    const Δλ = (cordinate2.lon - cordinate1.lon) * Math.PI/180

    const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
              Math.cos(φ1) * Math.cos(φ2) *
              Math.sin(Δλ/2) * Math.sin(Δλ/2)
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))

    const d = R * c // in metres
    const km = d / 1000
    const mi = km / 1.609344

    return Number(mi).toFixed(13)
  },
  angle: (x, y) => {
    const dy = x[1] - y[1]
    const dx = x[0] - y[0]

    return Math.round(Math.atan2(dy, dx) * 180 / Math.PI);
  },
  dataURLtoBlob: (dataurl) => {
    const arr = dataurl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])

    let n = bstr.length
    let u8arr = new Uint8Array(n)

    while (n--){
      u8arr[n] = bstr.charCodeAt(n)
    }

    return new Blob([u8arr], { type: mime })
  }
}
